import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import NamingTip from "./naming-tip.mdx";
import SettingProperties from "./setting-properties-text.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`import com.posthog.PostHog

PostHog.capture(event = "user_signed_up")
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`import com.posthog.PostHog

PostHog.capture(
    event = "user_signed_up",
    properties = mapOf(
        "login_type" to "email",
        "is_free_trial" to true
    )
)
`}</code></pre>
    <h3 {...{
      "id": "autocapture"
    }}>{`Autocapture`}</h3>
    <p>{`PostHog autocapture automatically tracks the following events for you:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Application Opened`}</strong>{` - when the app is opened from a closed state or when the app comes to the foreground. (e.g. from the app switcher)`}</li>
      <li parentName="ul"><strong parentName="li">{`Deep Link Opened`}</strong>{` - when the app is opened from a deep link.`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Backgrounded`}</strong>{` - when the app is sent to the background by the user.`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Installed`}</strong>{` - when the app is installed.`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Updated`}</strong>{` - when the app is updated.`}</li>
      <li parentName="ul"><strong parentName="li">{`$screen`}</strong>{` - when the user navigates. (if using `}<inlineCode parentName="li">{`android.app.Activity`}</inlineCode>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`$exception`}</strong>{` - when the app throws exceptions.`}</li>
    </ul>
    <h3 {...{
      "id": "capturing-screen-views"
    }}>{`Capturing screen views`}</h3>
    <p>{`With `}<a parentName="p" {...{
        "href": "/docs/libraries/android#all-configuration-options"
      }}><inlineCode parentName="a">{`captureScreenViews = true`}</inlineCode></a>{`, PostHog will try to record all screen changes automatically.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`screenTitle`}</inlineCode>{` will be the `}<a parentName="p" {...{
        "href": "https://developer.android.com/guide/topics/manifest/activity-element"
      }}><inlineCode parentName="a">{`<activity>`}</inlineCode></a>{`'s `}<inlineCode parentName="p">{`android:label`}</inlineCode>{`, if not set it'll fallback to the `}<a parentName="p" {...{
        "href": "https://developer.android.com/guide/topics/manifest/application-element"
      }}><inlineCode parentName="a">{`<application>`}</inlineCode></a>{`'s `}<inlineCode parentName="p">{`android:label`}</inlineCode>{` or the `}<a parentName="p" {...{
        "href": "https://developer.android.com/guide/topics/manifest/activity-element"
      }}><inlineCode parentName="a">{`<activity>`}</inlineCode></a>{`'s `}<inlineCode parentName="p">{`android:name`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<activity
    android:name="com.example.app.ChildActivity"
    android:label="@string/title_child_activity"
    ...
</activity>
`}</code></pre>
    <p>{`If you want to manually send a new screen capture event, use the `}<inlineCode parentName="p">{`screen`}</inlineCode>{` function.`}</p>
    <p>{`This function requires a `}<inlineCode parentName="p">{`screenTitle`}</inlineCode>{`. You may also pass in an optional `}<inlineCode parentName="p">{`properties`}</inlineCode>{` object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`import com.posthog.PostHog

PostHog.screen(
    screenTitle = "Dashboard",
    properties = mapOf(
        "background" to "blue",
        "hero" to "superhog"
    )
)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      